import React from 'react';

const steps = [
  { number: 1, label: 'Gói Đăng Ký' },
  { number: 2, label: 'Chọn Hoạt Động' },
  { number: 3, label: 'Đặt Mục Tiêu' }
];

export const WizardProgressBar = ({ currentStep, wizardPhase, configProgress }) => {
  // Show sub-step indicator when configuring activities
  const getStepLabel = (step) => {
    if (step.number === 2 && wizardPhase === 'configure' && configProgress) {
      return `Cấu Hình (${configProgress.current}/${configProgress.total})`;
    }
    return step.label;
  };

  return (
    <div className="mb-4" data-testid="wizard-progress">
      <div className="d-flex justify-content-between position-relative">
        {/* Progress line */}
        <div
          className="position-absolute bg-secondary"
          style={{
            top: '20px',
            left: '10%',
            right: '10%',
            height: '2px',
            zIndex: 0
          }}
        />
        {/* Completed progress line */}
        <div
          className="position-absolute bg-primary"
          style={{
            top: '20px',
            left: '10%',
            width: `${((currentStep - 1) / (steps.length - 1)) * 80}%`,
            height: '2px',
            zIndex: 1,
            transition: 'width 0.3s ease'
          }}
        />

        {steps.map((step) => {
          const isActive = step.number === currentStep;
          const isCompleted = step.number < currentStep;
          // Show pulsing animation when configuring
          const isConfiguring = step.number === 2 && wizardPhase === 'configure';

          return (
            <div
              key={step.number}
              className={`d-flex flex-column align-items-center ${isActive ? 'active' : ''}`}
              style={{ zIndex: 2, flex: 1 }}
              data-testid={`wizard-step-${step.number}`}
              data-wizard-step
            >
              <div
                className={`rounded-circle d-flex align-items-center justify-content-center mb-2 ${
                  isActive
                    ? 'bg-primary text-white active'
                    : isCompleted
                    ? 'bg-primary text-white'
                    : 'bg-light text-muted border'
                }`}
                style={{
                  width: '40px',
                  height: '40px',
                  fontWeight: 'bold',
                  transition: 'all 0.3s ease',
                  ...(isConfiguring && {
                    animation: 'pulse 2s infinite'
                  })
                }}
              >
                {isCompleted ? (
                  <i className="bi bi-check-lg"></i>
                ) : isConfiguring ? (
                  <i className="bi bi-gear"></i>
                ) : (
                  step.number
                )}
              </div>
              <span
                className={`small text-center ${
                  isActive ? 'text-primary fw-bold' : 'text-muted'
                }`}
              >
                {getStepLabel(step)}
              </span>
            </div>
          );
        })}
      </div>

      {/* CSS animation for configuring state */}
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </div>
  );
};
